import React from "react";
import { Col, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import { Field } from "formik";
import Icon from "react-icons-kit";
import { infoCircle } from "react-icons-kit/fa/infoCircle";

import FileUpload from "../FileUpload";

const CustomInputComponent = ({
  field, // { name, value, onChange, onBlur }

  form: { values, touched, errors, handleChange, handleBlur }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.

  ...props
}) => (
  <>
    <Form.Control
      isInvalid={!!errors[field.name]}
      isValid={touched[field.name] && !errors[field.name]}
      onChange={handleChange}
      onBlur={handleBlur}
      /* value={values[field.name]} */
      {...field}
      {...props}
    />
    <Form.Control.Feedback type={errors[field.name] ? "invalid" : "valid"}>
      {errors[field.name] ? errors[field.name] : "Looks good!"}
    </Form.Control.Feedback>
  </>
);

const renderBrandOption = (brandOptions) => {
  return brandOptions.map((item, index) => {
    return (
      <option key={index} value={item.name}>
        {item.name}
      </option>
    );
  });
};

const renderOptions = (options) => {
  return options.map((item) => {
    return (
      <option key={item.id} value={item.name}>
        {item.name}
      </option>
    );
  });
};

export const MobileForm = () => {
  return (
    <>
      <Form.Group as={Col} md="6">
        <Form.Label>Model</Form.Label>
        <Field
          component={CustomInputComponent}
          id="model_name"
          name="model_name"
          placeholder="Model"
          type="text"
        />
      </Form.Group>
      <Form.Group as={Col} md="6">
        <Form.Label>Brand</Form.Label>
        <Field
          component={CustomInputComponent}
          id="brand"
          name="brand"
          placeholder="Brand"
          type="text"
        />
      </Form.Group>
      <Form.Group as={Col} md="6">
        <Form.Label>Internal Storage</Form.Label>
        <Field
          component={CustomInputComponent}
          id="capacity"
          name="capacity"
          placeholder="Capacity"
          type="text"
        />
      </Form.Group>
      <Form.Group as={Col} md="6">
        <Form.Label>RAM</Form.Label>
        <Field
          component={CustomInputComponent}
          id="ram"
          name="ram"
          placeholder="RAM"
          type="number"
        />
      </Form.Group>
      <Form.Group as={Col} md="6">
        <Form.Label>Condition</Form.Label>
        <Field id="condition" name="condition">
          {({
            field, // { name, value, onChange, onBlur }

            form: { values, touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.

            meta,
          }) => (
            <>
              <Form.Control
                as="select"
                {...field}
                isInvalid={!!errors[field.name]}
                isValid={touched[field.name] && !errors[field.name]}
              >
                <option value="">Select One</option>
                <option value="Like new - Flawless">Like New - Flawless</option>
                <option value="Some signs of wear and tear">
                  Some signs of wear and tear
                </option>
                <option value="Partially defective">
                  Partially defective (specify in Other Details)
                </option>
                <option value="Fully not working">
                  Fully not working (specify in Other Details)
                </option>
              </Form.Control>
              <Form.Control.Feedback
                type={errors[field.name] ? "invalid" : "valid"}
              >
                {errors[field.name] ? errors[field.name] : "Looks good!"}
              </Form.Control.Feedback>
            </>
          )}
        </Field>
      </Form.Group>
      <Form.Group as={Col} md="6">
        <Form.Label>Age/Warranty</Form.Label>
        <Field id="warranty" name="warranty">
          {({
            field, // { name, value, onChange, onBlur }

            form: { values, touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.

            meta,
          }) => (
            <>
              <Form.Control
                as="select"
                {...field}
                isInvalid={!!errors[field.name]}
                isValid={touched[field.name] && !errors[field.name]}
              >
                <option value="">Warranty of the product</option>
                <option value="Less than 3 months old. At least 9 months valid warranty">
                  Less than 3 months old. At least 9 months valid warranty
                </option>
                <option value="Between 3 to 6 months old. At least 6 months valid warranty">
                  Between 3 to 6 months old. At least 6 months valid warranty
                </option>
                <option value="Between 6 to 11 months old. At least 1 months valid warranty">
                  Between 6 to 11 months old. At least 1 months valid warranty
                </option>
                <option value="More than 11 months old / No Warranty">
                  More than 11 months old / No Warranty
                </option>
              </Form.Control>
              <Form.Control.Feedback
                type={errors[field.name] ? "invalid" : "valid"}
              >
                {errors[field.name] ? errors[field.name] : "Looks good!"}
              </Form.Control.Feedback>
            </>
          )}
        </Field>
      </Form.Group>
      <Form.Group as={Col} md="6">
        <Form.Label>Accessories</Form.Label>
        <Field id="accessories" name="accessories">
          {({
            field, // { name, value, onChange, onBlur }

            form: { values, touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.

            meta,
          }) => (
            <>
              <Form.Control
                as="textarea"
                rows={2}
                {...field}
                isInvalid={!!errors[field.name]}
                isValid={touched[field.name] && !errors[field.name]}
                placeholder="Enlist the accompanying accessories you wish to sell. 
          For example - charger, invoice, box."
              />
              <Form.Control.Feedback
                type={errors[field.name] ? "invalid" : "valid"}
              >
                {errors[field.name] ? errors[field.name] : "Looks good!"}
              </Form.Control.Feedback>
            </>
          )}
        </Field>
      </Form.Group>
      <Form.Group as={Col} md="6">
        <Form.Label>
          Picture{" "}
          <OverlayTrigger
            key={"top"}
            placement={"top"}
            overlay={
              <Tooltip id={`tooltip-top`}>
                Allowed formats : gif, jpg, png, jpeg. Max-size : 2MB.
              </Tooltip>
            }
          >
            <span style={{ color: "#017ab3" }}>
              <Icon size={16} icon={infoCircle} />
            </span>
          </OverlayTrigger>
        </Form.Label>
        <div className="uploadfile d-flex align-items-center justify-content-between position-relative">
          <Field className="form-control" name="picture" component={FileUpload} />
          <span className="cf">Choose File</span>
          <span className="uf">Upload File</span>
        </div>
      </Form.Group>
      <Form.Group as={Col}>
        <Form.Label>Other details</Form.Label>
        <Field id="other_details" name="other_details">
          {({
            field, // { name, value, onChange, onBlur }

            form: { values, touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.

            meta,
          }) => (
            <>
              <Form.Control
                as="textarea"
                rows={2}
                {...field}
                isInvalid={!!errors[field.name]}
                isValid={touched[field.name] && !errors[field.name]}
                placeholder="Provide details of cosmetic or functional defects, if any. 
          Also feel free to provide any other information that may help us evaluate 
          the price of your gadget more accurately."
              />
              <Form.Control.Feedback
                type={errors[field.name] ? "invalid" : "valid"}
              >
                {errors[field.name] ? errors[field.name] : "Looks good!"}
              </Form.Control.Feedback>
            </>
          )}
        </Field>
      </Form.Group>
    </>
  );
};
export const TabletForm = () => {
  return (
    <>
      <Form.Group as={Col} md="6">
        <Form.Label>Model</Form.Label>
        <Field
          component={CustomInputComponent}
          id="model_name"
          name="model_name"
          placeholder="Model"
          type="text"
        />
      </Form.Group>
      <Form.Group as={Col} md="6">
        <Form.Label>Brand</Form.Label>
        <Field
          component={CustomInputComponent}
          id="brand"
          name="brand"
          placeholder="Brand"
          type="text"
        />
      </Form.Group>
      <Form.Group as={Col} md="6">
        <Form.Label>Internal Storage</Form.Label>
        <Field
          component={CustomInputComponent}
          id="capacity"
          name="capacity"
          placeholder="Capacity"
          type="text"
        />
      </Form.Group>
      <Form.Group as={Col} md="6">
        <Form.Label>RAM</Form.Label>
        <Field
          component={CustomInputComponent}
          id="ram"
          name="ram"
          placeholder="RAM"
          type="number"
        />
      </Form.Group>
      <Form.Group as={Col} md="6">
        <Form.Label>Condition</Form.Label>
        <Field id="condition" name="condition">
          {({
            field, // { name, value, onChange, onBlur }

            form: { values, touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.

            meta,
          }) => (
            <>
              <Form.Control
                as="select"
                {...field}
                isInvalid={!!errors[field.name]}
                isValid={touched[field.name] && !errors[field.name]}
              >
                <option value="">Select One</option>
                <option value="Like new - Flawless">Like New - Flawless</option>
                <option value="Some signs of wear and tear">
                  Some signs of wear and tear
                </option>
                <option value="Partially defective">
                  Partially defective (specify in Other Details)
                </option>
                <option value="Fully not working">
                  Fully not working (specify in Other Details)
                </option>
              </Form.Control>
              <Form.Control.Feedback
                type={errors[field.name] ? "invalid" : "valid"}
              >
                {errors[field.name] ? errors[field.name] : "Looks good!"}
              </Form.Control.Feedback>
            </>
          )}
        </Field>
      </Form.Group>
      <Form.Group as={Col} md="6">
        <Form.Label>Age/Warranty</Form.Label>
        <Field id="warranty" name="warranty">
          {({
            field, // { name, value, onChange, onBlur }

            form: { values, touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.

            meta,
          }) => (
            <>
              <Form.Control
                as="select"
                {...field}
                isInvalid={!!errors[field.name]}
                isValid={touched[field.name] && !errors[field.name]}
              >
                <option value="">Warranty of the product</option>
                <option value="Less than 3 months old. At least 9 months valid warranty">
                  Less than 3 months old. At least 9 months valid warranty
                </option>
                <option value="Between 3 to 6 months old. At least 6 months valid warranty">
                  Between 3 to 6 months old. At least 6 months valid warranty
                </option>
                <option value="Between 6 to 11 months old. At least 1 months valid warranty">
                  Between 6 to 11 months old. At least 1 months valid warranty
                </option>
                <option value="More than 11 months old / No Warranty">
                  More than 11 months old / No Warranty
                </option>
              </Form.Control>
              <Form.Control.Feedback
                type={errors[field.name] ? "invalid" : "valid"}
              >
                {errors[field.name] ? errors[field.name] : "Looks good!"}
              </Form.Control.Feedback>
            </>
          )}
        </Field>
      </Form.Group>
      <Form.Group as={Col} md="6">
        <Form.Label>Screen Size</Form.Label>
        <Field
          component={CustomInputComponent}
          id="screen_size"
          name="screen_size"
          placeholder="Screen Size"
          type="text"
        />
      </Form.Group>
      <Form.Group as={Col} md="6">
        <Form.Label>&nbsp;</Form.Label>
        <label className="dispb">
          <Field
            id="3g_voice_calling"
            name="3g_voice_calling"
            type="checkbox"
            value="Yes"
          />{" "}
          Cellular
        </label>
      </Form.Group>
      <Form.Group as={Col} md="6">
        <Form.Label>Accessories</Form.Label>
        <Field id="accessories" name="accessories">
          {({
            field, // { name, value, onChange, onBlur }

            form: { values, touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.

            meta,
          }) => (
            <>
              <Form.Control
                as="textarea"
                rows={2}
                {...field}
                isInvalid={!!errors[field.name]}
                isValid={touched[field.name] && !errors[field.name]}
                placeholder="Enlist the accompanying accessories you wish to sell. 
          For example - charger, invoice, box."
              />
              <Form.Control.Feedback
                type={errors[field.name] ? "invalid" : "valid"}
              >
                {errors[field.name] ? errors[field.name] : "Looks good!"}
              </Form.Control.Feedback>
            </>
          )}
        </Field>
      </Form.Group>
      <Form.Group as={Col} md="6">
        <Form.Label>
          Picture{" "}
          <OverlayTrigger
            key={"top"}
            placement={"top"}
            overlay={
              <Tooltip id={`tooltip-top`}>
                Allowed formats : gif, jpg, png, jpeg. Max-size : 2MB.
              </Tooltip>
            }
          >
            <span style={{ color: "#017ab3" }}>
              <Icon size={16} icon={infoCircle} />
            </span>
          </OverlayTrigger>
        </Form.Label>
        <div className="uploadfile d-flex align-items-center justify-content-between position-relative">
          <Field className="form-control" name="picture" component={FileUpload} />
          <span className="cf">Choose File</span>
          <span className="uf">Upload File</span>
        </div>
      </Form.Group>
      <Form.Group as={Col}>
        <Form.Label>Other details</Form.Label>
        <Field id="other_details" name="other_details">
          {({
            field, // { name, value, onChange, onBlur }

            form: { values, touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.

            meta,
          }) => (
            <>
              <Form.Control
                as="textarea"
                rows={2}
                {...field}
                isInvalid={!!errors[field.name]}
                isValid={touched[field.name] && !errors[field.name]}
                placeholder="Provide details of cosmetic or functional defects, if any. 
          Also feel free to provide any other information that may help us evaluate 
          the price of your gadget more accurately."
              />
              <Form.Control.Feedback
                type={errors[field.name] ? "invalid" : "valid"}
              >
                {errors[field.name] ? errors[field.name] : "Looks good!"}
              </Form.Control.Feedback>
            </>
          )}
        </Field>
      </Form.Group>
    </>
  );
};

export const LaptopForm = (props) => {
  const { laptopOption } = props;
  const { options, brand_options } = laptopOption;
  return (
    <>
      <Form.Group as={Col} md="6">
        <Form.Label>Model</Form.Label>
        <Field
          component={CustomInputComponent}
          id="model_name"
          name="model_name"
          placeholder="Model"
          type="text"
        />
      </Form.Group>
      <Form.Group as={Col} md="6">
        <Form.Label>Brand</Form.Label>
        <Field id="brand" name="brand">
          {({
            field, // { name, value, onChange, onBlur }

            form: { values, touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
          }) => (
            <>
              <Form.Control
                as="select"
                {...field}
                isInvalid={!!errors[field.name]}
                isValid={touched[field.name] && !errors[field.name]}
              >
                <option value="">Select One</option>
                {brand_options && renderBrandOption(brand_options)}
              </Form.Control>
              <Form.Control.Feedback
                type={errors[field.name] ? "invalid" : "valid"}
              >
                {errors[field.name] ? errors[field.name] : "Looks good!"}
              </Form.Control.Feedback>
            </>
          )}
        </Field>
      </Form.Group>
      <Form.Group as={Col} md="6">
        <Form.Label>Processor</Form.Label>
        <Field id="processor" name="processor">
          {({
            field, // { name, value, onChange, onBlur }

            form: { values, touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
          }) => (
            <>
              <Form.Control
                as="select"
                {...field}
                isInvalid={!!errors[field.name]}
                isValid={touched[field.name] && !errors[field.name]}
              >
                <option value="">Select One</option>
                {options && renderOptions(options.Processor.values)}
              </Form.Control>
              <Form.Control.Feedback
                type={errors[field.name] ? "invalid" : "valid"}
              >
                {errors[field.name] ? errors[field.name] : "Looks good!"}
              </Form.Control.Feedback>
            </>
          )}
        </Field>
      </Form.Group>
      <Form.Group as={Col} md="6">
        <Form.Label>OS Installed</Form.Label>
        <Field id="os_installed" name="os_installed">
          {({
            field, // { name, value, onChange, onBlur }

            form: { values, touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
          }) => (
            <>
              <Form.Control
                as="select"
                {...field}
                isInvalid={!!errors[field.name]}
                isValid={touched[field.name] && !errors[field.name]}
              >
                <option value="">Specify the installed operating system</option>
                <option value="Chrome OSs">Chrome OS</option>
                <option value="DOS">DOS</option>
                <option value="Linux">Linux</option>
                <option value="Mac OS X">Mac OS X</option>
                <option value="Windows 10">Windows 10</option>
                <option value="Windows 8">Windows 8</option>
                <option value="Windows 7">Windows 7</option>
                <option value="Windows Vista">Windows Vista</option>
                <option value="Windows XP">Windows XP</option>
                <option value="Windows NT">Windows NT</option>
                <option value="Windows ME">Windows ME</option>
                <option value="Windows 2003">Windows 2003</option>
                <option value="Windows 2000">Windows 2000</option>
                <option value="Windows 98">Windows 98</option>
                <option value="Windows 95">Windows 95</option>
                <option value="Other">Other</option>
              </Form.Control>
              <Form.Control.Feedback
                type={errors[field.name] ? "invalid" : "valid"}
              >
                {errors[field.name] ? errors[field.name] : "Looks good!"}
              </Form.Control.Feedback>
            </>
          )}
        </Field>
      </Form.Group>
      <Form.Group as={Col} md="6">
        <Form.Label>HDD Capacity</Form.Label>
        <Field id="capacity" name="capacity">
          {({
            field, // { name, value, onChange, onBlur }

            form: { values, touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
          }) => (
            <>
              <Form.Control
                as="select"
                {...field}
                isInvalid={!!errors[field.name]}
                isValid={touched[field.name] && !errors[field.name]}
              >
                <option value="">Select One</option>
                {options && renderOptions(options.Storage.values)}
              </Form.Control>
              <Form.Control.Feedback
                type={errors[field.name] ? "invalid" : "valid"}
              >
                {errors[field.name] ? errors[field.name] : "Looks good!"}
              </Form.Control.Feedback>
            </>
          )}
        </Field>
      </Form.Group>
      <Form.Group as={Col} md="6">
        <Form.Label>RAM</Form.Label>
        <Field id="ram" name="ram">
          {({
            field, // { name, value, onChange, onBlur }

            form: { values, touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
          }) => (
            <>
              <Form.Control
                as="select"
                {...field}
                isInvalid={!!errors[field.name]}
                isValid={touched[field.name] && !errors[field.name]}
              >
                <option value="">Select One</option>
                {options && renderOptions(options.RAM.values)}
              </Form.Control>
              <Form.Control.Feedback
                type={errors[field.name] ? "invalid" : "valid"}
              >
                {errors[field.name] ? errors[field.name] : "Looks good!"}
              </Form.Control.Feedback>
            </>
          )}
        </Field>
      </Form.Group>
      <Form.Group as={Col} md="6">
        <Form.Label>Condition</Form.Label>
        <Field id="condition" name="condition">
          {({
            field, // { name, value, onChange, onBlur }

            form: { values, touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.

            meta,
          }) => (
            <>
              <Form.Control
                as="select"
                {...field}
                isInvalid={!!errors[field.name]}
                isValid={touched[field.name] && !errors[field.name]}
              >
                <option value="">Select One</option>
                {options && renderOptions(options.PhysicalCondition.values)}
              </Form.Control>
              <Form.Control.Feedback
                type={errors[field.name] ? "invalid" : "valid"}
              >
                {errors[field.name] ? errors[field.name] : "Looks good!"}
              </Form.Control.Feedback>
            </>
          )}
        </Field>
      </Form.Group>
      <Form.Group as={Col} md="6">
        <Form.Label>Age/Warranty</Form.Label>
        <Field id="warranty" name="warranty">
          {({
            field, // { name, value, onChange, onBlur }

            form: { values, touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.

            meta,
          }) => (
            <>
              <Form.Control
                as="select"
                {...field}
                isInvalid={!!errors[field.name]}
                isValid={touched[field.name] && !errors[field.name]}
              >
                <option value="">Warranty of the product</option>
                <option value="">Warranty of the product</option>
                <option value="At least 3 months warranty">
                  At least 3 months warranty{" "}
                </option>
                <option value="More than 6 months warranty">
                  More than 6 months warranty{" "}
                </option>
                <option value="No Warranty">No Warranty </option>
              </Form.Control>
              <Form.Control.Feedback
                type={errors[field.name] ? "invalid" : "valid"}
              >
                {errors[field.name] ? errors[field.name] : "Looks good!"}
              </Form.Control.Feedback>
            </>
          )}
        </Field>
      </Form.Group>
      <Form.Group as={Col} md="6">
        <Form.Label>Screen Size</Form.Label>
        <Field id="screen_size" name="screen_size">
          {({
            field, // { name, value, onChange, onBlur }

            form: { values, touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
          }) => (
            <>
              <Form.Control
                as="select"
                {...field}
                isInvalid={!!errors[field.name]}
                isValid={touched[field.name] && !errors[field.name]}
              >
                <option value="">Select One</option>
                {options && renderOptions(options.ScreenSize.values)}
              </Form.Control>
              <Form.Control.Feedback
                type={errors[field.name] ? "invalid" : "valid"}
              >
                {errors[field.name] ? errors[field.name] : "Looks good!"}
              </Form.Control.Feedback>
            </>
          )}
        </Field>
      </Form.Group>
      <Form.Group as={Col} md="6">
        <Form.Label>Battery Life</Form.Label>
        <Field
          component={CustomInputComponent}
          id="battery_life"
          name="battery_life"
          placeholder="Battery life (hour)"
          type="text"
        />
      </Form.Group>
      <Form.Group as={Col} md="6">
        <Form.Label>Accessories</Form.Label>
        <Field id="accessories" name="accessories">
          {({
            field, // { name, value, onChange, onBlur }

            form: { values, touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.

            meta,
          }) => (
            <>
              <Form.Control
                as="textarea"
                rows={2}
                {...field}
                isInvalid={!!errors[field.name]}
                isValid={touched[field.name] && !errors[field.name]}
                placeholder="Enlist the accompanying accessories you wish to sell. 
          For example - charger, invoice, box."
              />
              <Form.Control.Feedback
                type={errors[field.name] ? "invalid" : "valid"}
              >
                {errors[field.name] ? errors[field.name] : "Looks good!"}
              </Form.Control.Feedback>
            </>
          )}
        </Field>
      </Form.Group>
      <Form.Group as={Col} md="6">
        <Form.Label>
          Picture{" "}
          <OverlayTrigger
            key={"top"}
            placement={"top"}
            overlay={
              <Tooltip id={`tooltip-top`}>
                Allowed formats : gif, jpg, png, jpeg. Max-size : 2MB.
              </Tooltip>
            }
          >
            <span style={{ color: "#017ab3" }}>
              <Icon size={16} icon={infoCircle} />
            </span>
          </OverlayTrigger>
        </Form.Label>
        <div className="uploadfile d-flex align-items-center justify-content-between position-relative">
          <Field className="form-control" name="picture" component={FileUpload} />
          <span className="cf">Choose File</span>
          <span className="uf">Upload File</span>
        </div>
      </Form.Group>
      <Form.Group as={Col} md="6">
        <Form.Label>Dedicated Graphics</Form.Label>
        <Field id="dedicated_graphics" name="dedicated_graphics">
          {({
            field, // { name, value, onChange, onBlur }

            form: { values, touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.

            meta,
          }) => (
            <>
              <Form.Control
                as="select"
                {...field}
                isInvalid={!!errors[field.name]}
                isValid={touched[field.name] && !errors[field.name]}
              >
                <option value="">Select One</option>
                {options && renderOptions(options.DedicatedGraphics.values)}
              </Form.Control>
              <Form.Control.Feedback
                type={errors[field.name] ? "invalid" : "valid"}
              >
                {errors[field.name] ? errors[field.name] : "Looks good!"}
              </Form.Control.Feedback>
            </>
          )}
        </Field>
      </Form.Group>
      <Form.Group as={Col} md="6">
        <Form.Label>Touchscreen</Form.Label>
        <Field id="touchscreen" name="touchscreen">
          {({
            field, // { name, value, onChange, onBlur }

            form: { values, touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.

            meta,
          }) => (
            <>
              <Form.Control
                as="select"
                {...field}
                isInvalid={!!errors[field.name]}
                isValid={touched[field.name] && !errors[field.name]}
              >
                <option value="">Select One</option>
                {options && renderOptions(options.Touchscreen.values)}
              </Form.Control>
              <Form.Control.Feedback
                type={errors[field.name] ? "invalid" : "valid"}
              >
                {errors[field.name] ? errors[field.name] : "Looks good!"}
              </Form.Control.Feedback>
            </>
          )}
        </Field>
      </Form.Group>
      <Form.Group as={Col}>
        <Form.Label>Other details</Form.Label>
        <Field id="other_details" name="other_details">
          {({
            field, // { name, value, onChange, onBlur }

            form: { values, touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.

            meta,
          }) => (
            <>
              <Form.Control
                as="textarea"
                rows={2}
                {...field}
                isInvalid={!!errors[field.name]}
                isValid={touched[field.name] && !errors[field.name]}
                placeholder="Provide details of cosmetic or functional defects, if any. 
          Also feel free to provide any other information that may help us evaluate 
          the price of your gadget more accurately."
              />
              <Form.Control.Feedback
                type={errors[field.name] ? "invalid" : "valid"}
              >
                {errors[field.name] ? errors[field.name] : "Looks good!"}
              </Form.Control.Feedback>
            </>
          )}
        </Field>
      </Form.Group>
    </>
  );
};

export const AnotherGadgetForm = () => {
  return (
    <>
      <Form.Group as={Col} md="6">
        <Form.Label>Item Name</Form.Label>
        <Field
          component={CustomInputComponent}
          id="item_name"
          name="item_name"
          placeholder="Item Name"
          type="text"
        />
      </Form.Group>
      <Form.Group as={Col} md="6">
        <Form.Label>Model</Form.Label>
        <Field
          component={CustomInputComponent}
          id="model_name"
          name="model_name"
          placeholder="Model"
          type="text"
        />
      </Form.Group>
      <Form.Group as={Col} md="6">
        <Form.Label>Brand</Form.Label>
        <Field
          component={CustomInputComponent}
          id="brand"
          name="brand"
          placeholder="Brand"
          type="text"
        />
      </Form.Group>
      <Form.Group as={Col} md="6">
        <Form.Label>Age/Warranty</Form.Label>
        <Field id="warranty" name="warranty">
          {({
            field, // { name, value, onChange, onBlur }

            form: { values, touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.

            meta,
          }) => (
            <>
              <Form.Control
                as="select"
                {...field}
                isInvalid={!!errors[field.name]}
                isValid={touched[field.name] && !errors[field.name]}
                value={values.zone_id}
              >
                <option value="">Warranty of the product</option>
                <option value="Less than 3 months old. At least 9 months valid warranty">
                  Less than 3 months old. At least 9 months valid warranty
                </option>
                <option value="Between 3 to 6 months old. At least 6 months valid warranty">
                  Between 3 to 6 months old. At least 6 months valid warranty
                </option>
                <option value="Between 6 to 11 months old. At least 1 months valid warranty">
                  Between 6 to 11 months old. At least 1 months valid warranty
                </option>
                <option value="More than 11 months old / No Warranty">
                  More than 11 months old / No Warranty
                </option>
              </Form.Control>
              <Form.Control.Feedback
                type={errors[field.name] ? "invalid" : "valid"}
              >
                {errors[field.name] ? errors[field.name] : "Looks good!"}
              </Form.Control.Feedback>
            </>
          )}
        </Field>
      </Form.Group>
      <Form.Group as={Col} md="6">
        <Form.Label>Condition</Form.Label>
        <Field id="condition" name="condition">
          {({
            field, // { name, value, onChange, onBlur }

            form: { values, touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.

            meta,
          }) => (
            <>
              <Form.Control
                as="select"
                {...field}
                isInvalid={!!errors[field.name]}
                isValid={touched[field.name] && !errors[field.name]}
                value={values.zone_id}
              >
                <option value="">Select One</option>
                <option value="Like new - Flawless">Like New - Flawless</option>
                <option value="Some signs of wear and tear">
                  Some signs of wear and tear
                </option>
                <option value="Partially defective">
                  Partially defective (specify in Other Details)
                </option>
                <option value="Fully not working">
                  Fully not working (specify in Other Details)
                </option>
              </Form.Control>
              <Form.Control.Feedback
                type={errors[field.name] ? "invalid" : "valid"}
              >
                {errors[field.name] ? errors[field.name] : "Looks good!"}
              </Form.Control.Feedback>
            </>
          )}
        </Field>
      </Form.Group>
      <Form.Group as={Col} md="6">
        <Form.Label>
          Picture{" "}
          <OverlayTrigger
            key={"top"}
            placement={"top"}
            overlay={
              <Tooltip id={`tooltip-top`}>
                Allowed formats : gif, jpg, png, jpeg. Max-size : 2MB.
              </Tooltip>
            }
          >
            <span style={{ color: "#017ab3" }}>
              <Icon size={16} icon={infoCircle} />
            </span>
          </OverlayTrigger>
        </Form.Label>
        <div className="uploadfile d-flex align-items-center justify-content-between position-relative">
          <Field className="form-control" name="picture" component={FileUpload} />
          <span className="cf">Choose File</span>
          <span className="uf">Upload File</span>
        </div>
      </Form.Group>
      <Form.Group as={Col} md="6">
        <Form.Label>Specifications</Form.Label>
        <Field id="specs" name="specs">
          {({
            field, // { name, value, onChange, onBlur }

            form: { values, touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.

            meta,
          }) => (
            <>
              <Form.Control
                as="textarea"
                rows={2}
                {...field}
                isInvalid={!!errors[field.name]}
                isValid={touched[field.name] && !errors[field.name]}
                placeholder="Detailed specifications"
              />
              <Form.Control.Feedback
                type={errors[field.name] ? "invalid" : "valid"}
              >
                {errors[field.name] ? errors[field.name] : "Looks good!"}
              </Form.Control.Feedback>
            </>
          )}
        </Field>
      </Form.Group>
      <Form.Group as={Col} md="6">
        <Form.Label>Accessories</Form.Label>
        <Field id="accessories" name="accessories">
          {({
            field, // { name, value, onChange, onBlur }

            form: { values, touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.

            meta,
          }) => (
            <>
              <Form.Control
                as="textarea"
                rows={2}
                {...field}
                isInvalid={!!errors[field.name]}
                isValid={touched[field.name] && !errors[field.name]}
                placeholder="Enlist the accompanying accessories you wish to sell. 
          For example - charger, invoice, box."
              />
              <Form.Control.Feedback
                type={errors[field.name] ? "invalid" : "valid"}
              >
                {errors[field.name] ? errors[field.name] : "Looks good!"}
              </Form.Control.Feedback>
            </>
          )}
        </Field>
      </Form.Group>

      <Form.Group as={Col}>
        <Form.Label>Other details</Form.Label>
        <Field id="other_details" name="other_details">
          {({
            field, // { name, value, onChange, onBlur }

            form: { values, touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.

            meta,
          }) => (
            <>
              <Form.Control
                as="textarea"
                rows={2}
                {...field}
                isInvalid={!!errors[field.name]}
                isValid={touched[field.name] && !errors[field.name]}
                placeholder="Provide details of cosmetic or functional defects, if any. 
          Also feel free to provide any other information that may help us evaluate 
          the price of your gadget more accurately."
              />
              <Form.Control.Feedback
                type={errors[field.name] ? "invalid" : "valid"}
              >
                {errors[field.name] ? errors[field.name] : "Looks good!"}
              </Form.Control.Feedback>
            </>
          )}
        </Field>
      </Form.Group>
    </>
  );
};
